import { LoadingButton } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState } from 'react';
import { CmsCancelElibility } from '../../../../hooks/cancel-items-hooks';
import '../../../../styles/order-details.scss';
// Only for B2C
export var PostRemorseCancel = function (_a) {
    var _b = _a.buttonVariant, buttonVariant = _b === void 0 ? 'primary' : _b, customerType = _a.customerType, handleCancelEligibilityResult = _a.handleCancelEligibilityResult, orderDetailsData = _a.orderDetailsData;
    var _c = useThdCustomer(), isLoggedIn = _c.isLoggedIn, isExchangeCustomer = _c.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var postRemorseCancel = function () {
        setIsLoading(true);
        CmsCancelElibility(undefined, orderDetailsData, false, false, true, handleCancelEligibilityResult, customerType, isAuthTHDUser);
        setIsLoading(false);
    };
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(LoadingButton, { variant: buttonVariant, onClick: function () { return postRemorseCancel(); }, loading: isLoading }, "Request to Cancel")));
};
